import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

interface FormLoadingOverlayProps {
  isLoading: boolean;
  message?: string;
  darkMode?: boolean;
}

export const FormLoadingOverlay: React.FC<FormLoadingOverlayProps> = ({
  isLoading,
  message = 'Processando...',
  darkMode = false,
}) => {
  if (!isLoading) return null;

  return (
    <div className={cn(
      'absolute inset-0 z-50 flex items-center justify-center rounded-xl',
      darkMode ? 'bg-gray-900 bg-opacity-90' : 'bg-white bg-opacity-90'
    )}>
      <div className="text-center">
        <Loader2 className={cn(
          'w-12 h-12 mx-auto mb-3 animate-spin',
          darkMode ? 'text-blue-400' : 'text-blue-600'
        )} />
        <p className={cn(
          'text-sm font-medium',
          darkMode ? 'text-gray-300' : 'text-gray-700'
        )}>
          {message}
        </p>
      </div>
    </div>
  );
};
